import { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import "./Slider.css";
import images_slide from "../../constants/images_slide";

const slides = [
  {
    image: images_slide.img1,
    title: "Precision Drafting, On-Demand",
    desc: "From concept sketches to construction-ready drawings, we deliver accurate, buildable documents that keep your projects moving forward.",
  },
  {
    image: images_slide.img2,
    title: "Seamless Interior Extensions",
    desc: "We execute your interior vision with meticulous detailing, ensuring every space reflects your architectural standards and client expectations",
  },
  {
    image: images_slide.img3,
    title: "Photorealistic Visuals, Zero Delays",
    desc: "Transform your models into stunning, client-ready visuals that communicate your design intent clearly and compellingly",
  },
  {
    image: images_slide.img4,
    title: "Flawless Coordination, Guaranteed",
    desc: "Our BIM expertise delivers perfectly coordinated, clash-free models and precise documentation, reducing errors and streamlining your entire workflow",
  },
];

export default function Slider() {
  const [index, setIndex] = useState(0);
  const autoPlayRef = useRef(null);

  const imageRef = useRef(null);
  const titleWrap = useRef(null);
  const descWrap = useRef(null);

  /* ======================
     TEXT ANIMATE IN
  ====================== */
  const animateIn = () => {
    if (!titleWrap.current || !descWrap.current) return;

    gsap.set([titleWrap.current, descWrap.current], {
      y: 120,
      opacity: 1,
    });

    gsap.to(titleWrap.current, {
      y: 0,
      duration: 0.9,
      ease: "power4.out",
    });

    gsap.to(descWrap.current, {
      y: 0,
      duration: 0.9,
      delay: 0.15,
      ease: "power4.out",
    });
  };

  /* ======================
     TEXT ANIMATE OUT
  ====================== */
  const animateOut = (nextIndex) => {
    if (!titleWrap.current || !descWrap.current) {
      setIndex(nextIndex);
      return;
    }

    gsap.to(titleWrap.current, {
      y: -120,
      duration: 0.6,
      ease: "power4.in",
    });

    gsap.to(descWrap.current, {
      y: -120,
      duration: 0.6,
      delay: 0.1,
      ease: "power4.in",
      onComplete: () => setIndex(nextIndex),
    });
  };

  /* ======================
     IMAGE ZOOM ANIMATION
  ====================== */
  useEffect(() => {
    if (!imageRef.current) return;

    gsap.killTweensOf(imageRef.current);

    gsap.fromTo(
      imageRef.current,
      { scale: 1 },
      { scale: 1.15, duration: 8, ease: "none" }
    );

    animateIn();
  }, [index]);

  /* ======================
     AUTOPLAY
  ====================== */
  useEffect(() => {
    autoPlayRef.current = setInterval(() => {
      animateOut((index + 1) % slides.length);
    }, 6000);

    return () => clearInterval(autoPlayRef.current);
  }, [index]);

  const goToSlide = (i) => {
    if (i === index) return;
    clearInterval(autoPlayRef.current);
    animateOut(i);
  };

  return (
    <section className="hero">
      <div className="hero-image">
        <img ref={imageRef} src={slides[index].image} alt="" />
      </div>

      <div className="overlay" />

      <div className="hero-content">
        <div className="text-mask">
          <div ref={titleWrap}>
            <h1>{slides[index].title}</h1>
          </div>
        </div>

        <div className="text-mask">
          <div ref={descWrap}>
            <p>{slides[index].desc}</p>
          </div>
        </div>
      </div>

      <div className="dots">
        {slides.map((_, i) => (
          <span
            key={i}
            className={i === index ? "active" : ""}
            onClick={() => goToSlide(i)}
          />
        ))}
      </div>
    </section>
  );
}
